import { render } from "./ServiceTask.vue?vue&type=template&id=63c31d40&ts=true"
import script from "./ServiceTask.vue?vue&type=script&lang=ts"
export * from "./ServiceTask.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__